<template>
  <v-container class="py-10" id="budget">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <div class="subtitle" style="color:#f0b414">Investitionen</div>
        <h2>62. Verteilung des aktuellen IT-Budgets</h2>
        <p style="color: green">
          <b>UPDATE</b>
        </p>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "A062",
  computed: {
    chartOptions() {
      return {
        colorAxis: {
          minColor: "#FFFFFF",
          maxColor: "#d62b03"
        },
        tooltip: {
          valueSuffix: "%"
        },

        series: [
          {
            type: "treemap",
            layoutAlgorithm: "squarified",
            data: [
              {
                name: "Hard- und Software",
                value: 58.5,
                colorValue: 58.5
              },
              {
                name: "Externe Dienstleister",
                value: 28.4,
                colorValue: 28.4
              },
              {
                name: "Eigenes IT-Personal",
                value: 7.9,
                colorValue: 7.9
              },
              {
                name: "Sonstiges",
                value: 5.2,
                colorValue: 5.2
              }
            ],
            levels: [
              {
                level: 1,
                dataLabels: {
                  style: {
                    fontSize: "12px",
                    fontWeight: "normal",
                    textOutline: "none"
                  }
                }
              }
            ]
          }
        ],
        title: {
          text:
            "Welchen Anteil von Ihrem IT-Budget haben Sie für folgende Bereiche aufgewendet?"
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500
              },

              chartOptions: {
                xAxis: undefined,
                yAxis: undefined,
                series: [
                  {
                    levels: [
                      {
                        level: 1,
                        dataLabels: {
                          style: {
                            fontSize: "10px",
                            fontWeight: "normal",
                            textOutline: "none"
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Budget",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
